export default __webpack_public_path__ + "static/media/Sunward.9b39acd5.jpg";